// Deterministic avatar color picker. Same user id → same color across pages.
//
// Palette: 10 hand-picked pastel backgrounds with matching dark text. Tuned
// to read well on white surfaces and to play with the CE Bright Green / Cyan
// brand gradient ring.

type Swatch = { bg: string; text: string }

const PALETTE: Swatch[] = [
  { bg: '#D7F0A2', text: '#3F5A00' }, // green
  { bg: '#BEEAF2', text: '#00363F' }, // cyan
  { bg: '#FFD8B5', text: '#7C2D12' }, // orange
  { bg: '#FFC9DE', text: '#7A1F46' }, // pink
  { bg: '#D9D2FF', text: '#3B2A85' }, // violet
  { bg: '#FFE9A8', text: '#553600' }, // amber
  { bg: '#C9E7FF', text: '#1B4B7A' }, // sky
  { bg: '#F8C8C8', text: '#7A1B1B' }, // rose
  { bg: '#C8E6CB', text: '#1B5023' }, // mint
  { bg: '#E4D2BC', text: '#5A3A14' }, // sand
]

export function avatarSwatch(seed: number | string): Swatch {
  const n = typeof seed === 'number' ? seed : hashString(seed)
  const idx = Math.abs(n) % PALETTE.length
  return PALETTE[idx]
}

function hashString(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0
  }
  return h
}
